import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { rgxPassword } from 'src/utils/regex';

@Component({
    selector: 'app-field-validator',
    templateUrl: './field-validator.component.html',
    styleUrls: ['./field-validator.component.scss'],
    standalone: false
})
export class FieldValidatorComponent {

  @Input() fieldControl: UntypedFormControl;

  constructor() { }

  public getTextPattern(objectPattern): string {

    if (objectPattern.requiredPattern === `/${rgxPassword.source}/`) {

      return 'Field must contain a case letter, 6 characters, and a special character.';
    }

    return '';

  }

}
